import { COLLECTIONS, CollectionKey } from '@/types/collections'
import { runtimeEnv } from './runtimeEnv'
import { resolveCanonicalCollection } from '../../shared/collectionContract'

const KNOWN_COLLECTION_VALUES = new Set(Object.values(COLLECTIONS))

export function resolveCollectionName(input: CollectionKey | string): string {
  const normalized = resolveCanonicalCollection(String(input))
  const overrides = runtimeEnv.getCollectionOverrides()

  if (overrides[normalized]) {
    return overrides[normalized] as string
  }

  if ((COLLECTIONS as Record<string, string>)[normalized]) {
    const key = normalized as CollectionKey
    return overrides[key] || COLLECTIONS[key]
  }

  if (KNOWN_COLLECTION_VALUES.has(normalized as (typeof COLLECTIONS)[CollectionKey])) {
    return normalized
  }

  return String(input).trim()
}

export function getResolvedCollections(): Record<CollectionKey, string> {
  const overrides = runtimeEnv.getCollectionOverrides()
  const resolved = {} as Record<CollectionKey, string>

  (Object.keys(COLLECTIONS) as CollectionKey[]).forEach((key) => {
    resolved[key] = overrides[key] || COLLECTIONS[key]
  })

  return resolved
}
